import {
  Headphones,
  GraduationCap,
  Image,
  Video,
  Clapperboard,
  TrendingUp,
  Radar,
  Users,
  Compass,
  Mic,
  Briefcase,
  Newspaper,
  Megaphone,
  Zap,
  type LucideIcon,
} from "lucide-react";

// capability key → 图标(前端唯一 SOT)。key 必须与后端 xb_module_catalog.capability 一致。
// 图标是纯前端呈现,catalog API 不返回;新增能力在此登记一行,取不到回落 Zap。
// 消费方:ModulePicker(勾选器)、TenantPlanSection(租户详情模块网格)、工作台/侧栏「即将上线」。
export const MODULE_ICONS: Record<string, LucideIcon> = {
  ai_kefu: Headphones,
  ai_peilian: GraduationCap,
  ai_poster: Image,
  ai_video: Video,
  ai_digital_human: Clapperboard,
  biz_advisor: TrendingUp,
  geo_radar: Radar,
  seat: Users,
  advisor: Compass,
  dh_voice_profile: Mic,
  ai_business: Briefcase,
  ai_reporter: Newspaper,
  ai_promotion: Megaphone,
};

/** capability → 图标组件,缺登记回落 Zap(避免功能像缺失)。 */
export function moduleIcon(capability: string): LucideIcon {
  return MODULE_ICONS[capability] ?? Zap;
}
